import { HTTP_EDOCSIGN } from '../plugins/axios';

export default {
  findAll(params) {
    return HTTP_EDOCSIGN.get('/domain-groups', { params });
  },
  findById(domainGroupId) {
    return HTTP_EDOCSIGN.get(`/domain-groups/${domainGroupId}`);
  },
  create(payload) {
    return HTTP_EDOCSIGN.post('/domain-groups', payload);
  },
  update(domainGroupId, payload) {
    return HTTP_EDOCSIGN.put(`/domain-groups/${domainGroupId}`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/api/DomainGroupApi.js